// src/components/support/SupportHeroSection.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ImpactGridVisual } from '../../visuals/ImpactGridVisual';
import {Button} from '@dopomogai/ui';
import { HandHeart } from 'lucide-react';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2,
      ease: [0.25, 1, 0.5, 1],
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 1, 0.5, 1],
    },
  },
};

export const SupportHeroSection: React.FC = () => {
  const { t } = useTranslation('support_us');

  const handleCtaClick = () => {
    const element = document.getElementById('contribution-options');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="bg-slate-900 text-white min-h-[80vh] md:min-h-[70vh] flex items-center justify-center py-24 md:py-32 relative overflow-hidden">
      {/* Layer 1: The animated background visual */}
      <div className="absolute inset-0 z-0 opacity-40">
        <ImpactGridVisual />
      </div>

      {/* Layer 2: The vignette overlay for text readability */}
      <div className="absolute inset-0 z-10 bg-[radial-gradient(ellipse_at_center,transparent_20%,#0f172a_70%)]"></div>
      
      {/* Layer 3: The content */}
      <div className="container mx-auto px-4 text-center relative z-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h1
            variants={itemVariants}
            className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight bg-gradient-to-b from-white to-slate-300 text-transparent bg-clip-text"
            style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}
          >
            {t('hero.headline')}
          </motion.h1>

          <motion.p
            variants={itemVariants}
            className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-slate-300"
          >
            {t('hero.subheadline')}
          </motion.p>
          
          {/* --- THE FIX: ADDED flex justify-center --- */}
          <motion.div 
            variants={itemVariants} 
            className="mt-12 flex justify-center"
          >
            <Button
              text={t('hero.cta')}
              variant="primary"
              size="lg"
              onClick={handleCtaClick}
              icon={<HandHeart size={20} />}
              iconPosition="left"
              className="hover:shadow-[4px_4px_0_0_#34d399]"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

